//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Workouts4_Banner',
};
